import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import './Accordion.css';
import {
  HomeUpdatedonedev,
  HomeUpdatedtwodev,
  HomeUpdatedthreedev,
  HomeUpdatedfourdev,
  HomeUpdatedfivedev,
  HomeUpdatedsixdev,
  HomeUpdatedsevendev,
  HomeUpdatedeightdev,
  discoveryBackground,
  HomeUpdatedArrowIcon,
} from "../../../app-constants";

const AccordionItem = ({
  title,
  icon,
  contentMainTitle,
  contentMainContent,
  contentTitle,
  content,
  Link,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="card">
      <div
        className={`card-header ${isOpen ? "active" : ""}`}
        onClick={onToggle}
      >
        {title}
        <div className="svg-arrow-icon d-block d-lg-none">
          {HomeUpdatedArrowIcon}
        </div>
      </div>
      <div className={`collapse ${isOpen ? "show width" : "width"}`}>
        <div className="card-body">
          <div className="discovery-bg">{discoveryBackground}</div>
          <div className="arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="36"
              fill="none"
              viewBox="0 0 20 36"
            >
              <path
                stroke="#F47A1F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M1.893 2.377l15.62 15.62-15.62 15.62"
              ></path>
            </svg>
          </div>
          <div
            className="main-title"
            dangerouslySetInnerHTML={{ __html: contentMainTitle }}
          />
          <div className="main-title-content">
            <p dangerouslySetInnerHTML={{ __html: contentMainContent }} />
          </div>
          <div class="content-wrap">
            <div class="icon">{icon}</div>
            <h3
              className="title"
              dangerouslySetInnerHTML={{ __html: contentTitle }}
            />
            <p dangerouslySetInnerHTML={{ __html: content }} />
            {/* <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              {{ __html: Link }}
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

function DiscoveryAcc() {
  const [activeIndex, setActiveIndex] = useState(0);

  // const handleToggle = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  const handleToggle = (index) => {
    // Set activeIndex to the clicked index if it's different from the current active index
    setActiveIndex(activeIndex === index ? activeIndex : index);
  };

  return (
    <section className="tekrevol-home-discovery overflow-x-hidden b2b-portal-seamless telecom-process">
      <div className="accordion width" id="accordionHorizontalExample">
        <AccordionItem
          title="Discovery & Analysis"
          contentMainTitle="Our Proven Approach to <span>Construction Software</span> Development</span>"
          contentMainContent="At Tekrevol, we are an agile-driven construction software development company that always prioritizes your needs. Our proven approach ensures we deliver high-quality solutions on time and within budget."
          icon={HomeUpdatedonedev}
          contentTitle="Discovery & Analysis"
          content="Every project begins with discovery sessions where our experts understand your business needs and project goals to create a roadmap for success."
          // Link="Talk to Our Experts"
          isOpen={activeIndex === 0}
          onToggle={() => handleToggle(0)}
        />
        <AccordionItem
          title="Design & Prototyping"
          contentMainTitle="Our Proven Approach to <span>Construction Software</span> Development</span>"
          contentMainContent="At Tekrevol, we are an agile-driven construction software development company that always prioritizes your needs. Our proven approach ensures we deliver high-quality solutions on time and within budget."
          icon={HomeUpdatedtwodev}
          contentTitle="Design & Prototyping"
          content="Expert design teams at Tekrevol create user-centric and interactive prototypes that help you visualize your product before we move to the development phase."
          isOpen={activeIndex === 1}
          onToggle={() => handleToggle(1)}
        />
        <AccordionItem
          title="Development & Integration"
          contentMainTitle="Our Proven Approach to <span>Construction Software</span> Development</span>"
          contentMainContent="At Tekrevol, we are an agile-driven construction software development company that always prioritizes your needs. Our proven approach ensures we deliver high-quality solutions on time and within budget."
          icon={HomeUpdatedthreedev}
          contentTitle="Development & Integration"
          content="We follow an agile methodology to develop your robust, secure, and scalable construction software that seamlessly integrates with your current tools."
          isOpen={activeIndex === 2}
          onToggle={() => handleToggle(2)}
        />
        <AccordionItem
          title="Testing & QA"
          contentMainTitle="Our Proven Approach to <span>Construction Software</span> Development</span>"
          contentMainContent="At Tekrevol, we are an agile-driven construction software development company that always prioritizes your needs. Our proven approach ensures we deliver high-quality solutions on time and within budget."
          icon={HomeUpdatedfourdev}
          contentTitle="Testing & QA"
          content="We perform multiple layers of testing to identify and solve potential issues in your software while focusing on performance, security, and functionality."
          isOpen={activeIndex === 3}
          onToggle={() => handleToggle(3)}
        />
        <AccordionItem
          title="Deployment & Support"
          contentMainTitle="Our Proven Approach to <span>Construction Software</span> Development</span>"
          contentMainContent="At Tekrevol, we are an agile-driven construction software development company that always prioritizes your needs. Our proven approach ensures we deliver high-quality solutions on time and within budget."
          icon={HomeUpdatedfivedev}
          contentTitle="Deployment & Support"
          content="Our teams assist you with a smooth software launch and provide dedicated support to ensure your software is up and running and meets the user's demands."
          isOpen={activeIndex === 4}
          onToggle={() => handleToggle(4)}
        />
        {/* <AccordionItem
          title="Maintenance"
          contentMainTitle="Our Proven <span>AI Development Process</span> at TekRevol</span>"
          contentMainContent="We follow an agile-based process to develop, integrate, implement, and deploy artificial intelligence solutions. Our tried-and-tested 6-step process ensures your solutions are customized to your business needs and delivered within the budget on time."
          icon={HomeUpdatedsixdev}
          contentTitle="Maintenance"
          content="In the maintenance stage, we ensure the continuous optimal performance of your AI software through diligent monitoring and regular updates. We track key performance indicators (KPIs) detect anomalies or performance degradations, and take immediate corrective actions when necessary. Our team conducts periodic model retraining with new data to maintain accuracy and relevance. AI maintenance teams provide regular updates to ensure stability and efficiency."
          isOpen={activeIndex === 5}
          onToggle={() => handleToggle(5)}
        /> */}
        {/* <AccordionItem
          title="Support & Expand"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedsevendev}
          contentTitle="Support & Expand"
          content="We provide support and maintenance services for updating and optimizing your application further in use. We also work to expand and enhance your application, adding new features and functionalities as the business expands."
          isOpen={activeIndex === 6}
          onToggle={() => handleToggle(6)}
        /> */}
        {/* <AccordionItem
          title="Continuous Support & Optimization"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedeightdev}
          contentTitle="Continuous Support & Optimization"
          content="Offer ongoing support and optimization services. Monitor performance, gather feedback, and implement enhancements to drive sustained growth and innovation"
          isOpen={activeIndex === 7}
          onToggle={() => handleToggle(7)}
        /> */}
      </div>
    </section>
  );
}

export default DiscoveryAcc;
